import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {ChargeService} from './charge.service';
import {ChargeDatatableComponent} from './charge-datatable.component';
import {ChargeFormComponent} from './charge-form.component';

@NgModule({
  declarations: [
    ChargeDatatableComponent,
    ChargeFormComponent
  ],
  exports: [
    ChargeDatatableComponent,
    ChargeFormComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ChargeService
  ]
})
export class ChargeModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/charge/charge.module.ts